module.exports = __webpack_public_path__ + "static/media/3-circle-dirty.d103ab96.svg";